import React from "react";
import loginToGoogle from "./loginToGoogle.png";

const Login = () => {
    const domain = process.env.NODE_ENV === "development" ? (process.env.REACT_APP_API_ORIGIN ?? "http://localhost:54306") : "";
    const loginRoute = `${domain}/api/auth/login`;

    return (
        <div
            dir="rtl"
            style={{
                minHeight: "100vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "24px",
                boxSizing: "border-box",
                background: "linear-gradient(135deg, #2f80ed 0%, #1c9e8c 100%)"
            }}
        >
            <div
                style={{
                    background: "white",
                    borderRadius: "16px",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
                    padding: "40px 32px",
                    width: "100%",
                    maxWidth: "380px",
                    textAlign: "center"
                }}
            >
                <img
                    src="/icon-192.png"
                    alt="ניהול תקציב"
                    style={{ width: "72px", height: "72px", borderRadius: "16px", marginBottom: "16px" }}
                />
                <h1 style={{ fontSize: "22px", fontWeight: 600, margin: "0 0 6px", color: "#222" }}>ניהול תקציב</h1>
                <p style={{ color: "#7f8c8d", fontSize: "14px", margin: "0 0 28px" }}>התחברות לחשבון</p>
                <a href={loginRoute} style={{ display: "inline-block" }}>
                    <img src={loginToGoogle} alt="Sign in with Google" style={{ height: "44px" }} />
                </a>
            </div>
        </div>
    );
};

export default Login;
